import { CgsEvent } from './Event';
import { Mouse } from './Mouse';
import { CGSMouseEvent } from './MouseEvent';

export class AbstractMouseEvent extends CgsEvent {
  mouse: Mouse;
  event: CGSMouseEvent;

  constructor(mouse: Mouse, event: CGSMouseEvent) {
    super();
    this.mouse = mouse;
    this.event = event;
  }
}
